import { render, staticRenderFns } from "./act-item.vue?vue&type=template&id=f404d8ec&scoped=true&"
import script from "./act-item.vue?vue&type=script&lang=js&"
export * from "./act-item.vue?vue&type=script&lang=js&"
import style0 from "./act-item.vue?vue&type=style&index=0&id=f404d8ec&scoped=true&lang=scss&"
import style1 from "./act-item.vue?vue&type=style&index=1&id=f404d8ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f404d8ec",
  null
  
)

export default component.exports